<template>
  <div>
    <el-table
      :data="items"
      border
      size="small"
      class="mt-10"
      v-loading="loading"
      ref="table"
    >
      <el-table-column fixed="left" align="center" label="编码" prop="code">
      </el-table-column>
      <el-table-column align="center" label="库存基地" prop="base.name">
      </el-table-column>
      <el-table-column
        align="center"
        label="钻井"
        prop="drill_well.well_number"
      >
      </el-table-column>
      <el-table-column
        align="center"
        :label="param.label"
        :prop="param.key"
        v-for="param in template.custom_params"
        :key="param.key + param.label"
        :min-width="labelWidth(param.label)"
      >
        <template slot-scope="scope">
          {{
            scope.row.custom_params.filter((item) => item.label == param.label)
              .length > 0
              ? scope.row.custom_params.filter(
                  (item) => item.label == param.label,
                )[0].value
              : '-'
          }}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="number" label="数量">
      </el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <div style="display: flex; justify-content: center; flex-wrap: wrap">
            <el-button
              type="text"
              size="mini"
              v-permission="Auth.productGroupStockEdit"
              @click="handleEdit(scope.row, scope.$index)"
              >编辑库存</el-button
            >
            <ProductDialog :model="scope.row" :showRecords="true">
              <el-button type="text" size="mini"
                >查看记录</el-button
              ></ProductDialog
            >
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="table-footer">
      <!-- <el-button
        type="primary"
        size="small"
        @click="batchTransfer"
        v-if="total > 0"
        v-permission="
          template.category == 1 ? Auth.productEdit : Auth.instrumentEdit
        "
        >批量转移分组</el-button
      > -->
      <el-pagination
        :page-sizes="[10, 20, 50, 100]"
        :page-size="filter.size"
        :current-page.sync="filter.page"
        @size-change="handleSizeChange"
        @current-change="getData"
        layout="total,sizes, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
    <TransferFormer
      :model="model"
      :show.sync="transferFormerVisible"
      @callback="getData"
    ></TransferFormer>
    <ProductInventoryFormer
      :model="model"
      :show.sync="numberFormerVisible"
      @callback="handleInventoryCallback"
    ></ProductInventoryFormer>
  </div>
</template>

<script>
import { productList } from '@/service/getData'
import TransferFormer from './transfer_former.vue'
import ProductInventoryFormer from './ProductInventoryFormer.vue'

export default {
  components: {
    TransferFormer,
    ProductInventoryFormer,
  },
  props: {
    template: Object,
    filter: Object,
    canTransfer: Boolean,
  },
  data() {
    return {
      items: [],
      total: 0,
      model: {},
      transferFormerVisible: false,
      editIndex: 0,
      numberFormerVisible: false,
      loading: false,
    }
  },
  computed: {
    labelWidth() {
      return function (label) {
        const canvas = document.createElement('canvas')
        const context = canvas.getContext('2d')
        context.font = '14px Microsoft YaHei'
        const dimension = context.measureText(label)

        let width = dimension.width + 20
        if (width < 90) {
          width = 90
        }
        if (label == '螺杆规格') {
          width = 110
        }
        return width
      }
    },
  },
  methods: {
    async getData() {
      this.$router.replace({
        query: { filter: JSON.stringify(this.filter) },
      })

      let data = this.clone(this.filter)
      data.page -= 1
      if (data.date && data.date.length == 2) {
        data.start_date = data.date[0]
        data.end_date = data.date[1]
      }
      this.loading = true
      let res = await productList(data)
      if (res.status == 0) {
        this.items = res.data.list
        this.total = res.data.count
        this.loading = false
      }
    },
    handleSizeChange(size) {
      this.filter.size = size
      this.filter.page = 1
      this.getData()
    },
    // clearTableSelected() {
    //   this.$refs.table.clearSelection()
    // },
    batchTransfer() {
      let options = []
      if (this.template.children_groups) {
        options = this.template.children_groups.split('、')
      }
      this.model = {
        name: this.template.name,
        options: options,
        filter: this.filter,
        total: this.total,
        group_name: '',
      }
      this.transferFormerVisible = true
    },

    handleEdit(item, index) {
      this.model = {
        id: item.id,
        old_number: item.number,
        number: item.number,
        remark: '',
      }
      this.editIndex = index
      this.numberFormerVisible = true
    },

    handleInventoryCallback(res) {
      this.items[this.editIndex].number = res.number
      this.$notify.success('更新成功！')
    },
  },
}
</script>

<style scoped>
.table-footer {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}
</style>